import { createContext } from 'react';

const TypeTransferContext = createContext({
    typeTransfer: 1,
    setTypeTransfer: () => {},
});

export default TypeTransferContext; 
